export default "__VITE_ASSET__BM_b29qN__"